export const SORT_TYPES = Object.freeze({
    NAME: 'name',
    LAST_ACTIVITY: 'lastActivity',
    HEALTH: 'health',
    UNIT: 'unit',
    ACTIONS: 'actions',
});

export const LANGUAGES = [
    { label: 'English', value: 'en' },
    { label: 'عربي', value: 'ar' },
    { label: 'Español', value: 'es' },
    { label: 'română', value: 'ro' },
    { label: 'українська', value: 'uk' },
    { label: 'Azərbaycan dili', value: 'az' },
    { label: 'Русский', value: 'ru' },
    { label: 'български', value: 'bg' },
    { label: 'český', value: 'cs' },
    { label: 'Français', value: 'fr' },
    { label: 'Deutsch', value: 'de' },
    { label: 'magyar', value: 'hu' },
    { label: 'Indonesia', value: 'id' },
    { label: '日本語', value: 'ja' },
    { label: 'Malaysia', value: 'ms' },
    { label: 'Polski', value: 'pl' },
    { label: 'Portugais', value: 'pt' },
    { label: 'Português (Brasil)', value: 'pt-BR' },
    { label: 'සිංහල (ශ්‍රී ලංකාව)', value: 'si' },
    { label: '台灣', value: 'zh' },
    { label: 'แบบไทย', value: 'th' },
    { label: 'Tiếng Việt', value: 'vi' },
    { label: "o'zbek", value: 'uz' },
];

export const NotificationFlags = Object.freeze({
    Processing: 0,
    Delivered: 1,
    Failed: 2,
});
